function formatMoney(cents, format) {
  // Use Shopify's money format from theme settings, fallback to INR
  const moneyFormat = format || window.Shopify?.money_format || '₹{{amount}}';

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


document.addEventListener('DOMContentLoaded', function () {
  const phoneInput = document.getElementById('ContactForm-phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 10);
    });
  }
});



// document.addEventListener('DOMContentLoaded', function () {
//   const customBtn = document.querySelector('.cst-button');
//   const errorMsg = document.querySelector('.pack-error-message');
//   const themeBtn = document.querySelector('.theme-add-to-cart');

//   if (customBtn) {
//     customBtn.addEventListener('click', function () {
//       let allValid = true;

//       // Find all required select dropdowns inside pack section
//       const selects = document.querySelectorAll('.pack-selection-wrapper select');

//       selects.forEach(select => {
//         if (!select.value) {
//           allValid = false;
//           select.classList.add('error-border');
//         } else {
//           select.classList.remove('error-border');
//         }
//       });

//       if (!allValid) {
//         errorMsg.style.display = 'block';
//       } else {
//         errorMsg.style.display = 'none';
//         customBtn.style.display = 'none';
//         themeBtn.style.display = 'block';
//       }
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  const selects = document.querySelectorAll('.pack-selection-wrapper select');

  selects.forEach(select => {
    select.addEventListener('change', function () {
      const placeholderOption = this.querySelector('option[value=""]');
      if (this.value !== "" && placeholderOption) {
        placeholderOption.disabled = true;
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const customBtn = document.querySelector('.cst-button');
  if (!customBtn) return; // Exit if no metafields (theme button already visible)

  const themeAddToCart = document.querySelector('.theme-add-to-cart');
  const errorMessage = document.querySelector('.pack-error-message');
  const selects = document.querySelectorAll('.pack-selection-wrapper select');

  themeAddToCart.style.display = 'none';

  function allSelected() {
  return Array.from(selects).every(select => {
    return select.disabled || select.value.trim() !== '';
  });
}

  function removeErrors() {
    selects.forEach(select => select.classList.remove('error-border'));
    errorMessage.style.display = 'none';
  }

  selects.forEach(select => {
    select.addEventListener('change', function () {
      if (allSelected()) {
        themeAddToCart.style.display = 'block';
        customBtn.style.display = 'none';
        removeErrors();
      } else {
        themeAddToCart.style.display = 'none';
        customBtn.style.display = 'inline-block';
      }
    });
  });

  customBtn.addEventListener('click', function () {
    if (!allSelected()) {
      errorMessage.style.display = 'block';
      selects.forEach(select => {
        if (!select.disabled && select.value.trim() === '') {
          select.classList.add('error-border');
        } else {
          select.classList.remove('error-border');
        }
      });

    }
  });
});



// Added By MS

// Added By MS


// API
async function getCart() {
  return await fetch('/cart.js').then(r => r.json());
}
async function getProduct(handle) {
  return await fetch(`/products/${handle}.js`).then(r => r.json());
}

// GLOBAL STATE
let lastItemCount = null;
let popupInProgress = false;
// POPUP CONTROL
function openPopup(type) {
  if (popupInProgress) return;
  popupInProgress = true;
  document.getElementById(type + '-popup').style.display = 'block';
  document.body.classList.add('overlay-popup');
}
function closePopup(type) {
  document.getElementById(type + '-popup').style.display = 'none';
  popupInProgress = false;
  const anyOpen = document.querySelector('.popup[style*="block"]');
  if (!anyOpen) {
    document.body.classList.remove('overlay-popup');
  }
}

async function loadProduct(handle, type, allowedVariants = null) {
  if (!handle) return;

  const product = await getProduct(handle);
  window.fsrProductData = product; // existing use
window.allowedUpsellVariants = allowedVariants; // ✅ ADD THIS

  document.getElementById(type+'-title').innerText = product.title;
  // document.getElementById(type+'-img').src = product.images[0];
  const wrapper = document.querySelector('.img-title-data .variant-option__select-wrapper');

  const select = document.getElementById(type+'-variant');
  select.innerHTML = '';

  let filteredVariants = product.variants;
 

  // 🎯 FILTER USING METAFIELD
  if (allowedVariants && allowedVariants.length > 0) {
    const allowedIds = allowedVariants.map(v => v.id);

    filteredVariants = product.variants.filter(v => 
      allowedIds.includes(v.id)
    );
  }

   // =====================
// SET DEFAULT SELECTED VARIANT
// =====================
let selectedVariant = null;

// 🔥 MOST IMPORTANT
if (allowedVariants && allowedVariants.length > 0) {
  selectedVariant = allowedVariants[0]; // exact mapping
} else if (filteredVariants.length > 0) {
  selectedVariant = filteredVariants[0];
}

// 🎯 SET IMAGE DIRECTLY (NO FLASH)
// 🎯 IMAGE LOGIC

let imageUrl = '';

// 🎁 CASE: GIFT → use product image
if (type === 'gift') {

  if (product.featured_image) {
    imageUrl = product.featured_image;
  } else if (product.images && product.images.length > 0) {
    imageUrl = product.images[0];
  }

}

// 🔥 CASE: UPSELL → use variant image
else if (selectedVariant?.featured_image?.src) {

  imageUrl = selectedVariant.featured_image.src.startsWith('//')
    ? 'https:' + selectedVariant.featured_image.src
    : selectedVariant.featured_image.src;

}

// ✅ APPLY IMAGE
if (imageUrl) {
  document.getElementById(type+'-img').src = imageUrl;
}

  // =====================
  // CASE 1: ONLY 1 VARIANT
  // =====================
  if (filteredVariants.length === 1) {
    const variantText = document.querySelector('.img-title-data .variant-text');

    const v = filteredVariants[0];

    select.innerHTML = `<option value="${v.id}">${v.title}</option>`;
    select.style.display = 'none'; // ❌ hide dropdown
    wrapper.style.display = 'none';

    // show only title
    // document.getElementById(type+'-title').innerText += ` - ${v.title}`;
    variantText.innerText = v.title;

    // Added by MS
    const variantPrice = document.querySelector('.img-title-data .variant-price');
    // variantPrice.innerText = formatMoney(v.price,window.Shopify.money_format);


    let displayPrice = v.price;

    if (window.upsellPriceMap && window.upsellPriceMap[v.id]) {
      displayPrice = window.upsellPriceMap[v.id];
    }

    variantPrice.innerText = formatMoney(displayPrice, window.Shopify.money_format);

  } else {
    // =====================
    // CASE 2: MULTIPLE VARIANTS
    // =====================
    select.style.display = 'block';
    wrapper.style.display = 'block';

    filteredVariants.forEach(v => {
        const isSelected = selectedVariant && v.id == selectedVariant.id;
        select.innerHTML += `<option data-price="${v.price}" value="${v.id}" ${isSelected ? 'selected' : ''}>${v.title}</option>`;
    });

      const variantPrice = document.querySelector('.img-title-data .variant-price');

      if (selectedVariant && variantPrice) {
        let displayPrice = selectedVariant.price;

        if (window.upsellPriceMap && window.upsellPriceMap[selectedVariant.id]) {
          displayPrice = window.upsellPriceMap[selectedVariant.id];
        }

        variantPrice.innerText = formatMoney(displayPrice, window.Shopify.money_format);
      }

  }
}
// WATCH CART
async function watchCart() {
  const cart = await getCart();
  
  if (lastItemCount === null) {
    lastItemCount = cart.item_count;
    return;
  }
  // 🔥 ITEM ADDED
  if (cart.item_count > lastItemCount && !popupInProgress) {
    console.log("🟢 Cart Updated");
    for (let item of cart.items) {
      const hasUpsell = item.properties?._trigger_upsell == 'true';
      const hasGift = item.properties?._trigger_gift == 'true';
      // 🔥 UPSELL FIRST
     if (hasUpsell && !localStorage.getItem('upsell_shown')) {
      let allowedVariants = null;
      if (item.properties?._upsell_variants) {
        try {
          allowedVariants = JSON.parse(item.properties._upsell_variants);
          
        } catch (e) {
          console.log("Variant parse error");
        }
      }

      let upsellPriceMap = null;
      if (item.properties?._upsell_variant_data) {
        try {
          upsellPriceMap = JSON.parse(item.properties._upsell_variant_data);
        } catch(e) {
          console.log("Price parse error");
        }
      }

      window.upsellPriceMap = upsellPriceMap;


      await loadProduct(
        item.properties._upsell_handle,
        'fsr',
        allowedVariants
      );
      openPopup('fsr');
      localStorage.setItem('upsell_shown', 'true');
      return;
    }
      // 🎁 ONLY GIFT (NO UPSELL)
      if (
        hasGift &&
        !hasUpsell &&
        !localStorage.getItem('gift_shown')
      ) {
        console.log("🎁 Opening Gift");
        await loadProduct(item.properties._gift_handle, 'gift');
        openPopup('gift');
        localStorage.setItem('gift_shown', 'true');
        return;
      }
    }
  }
  lastItemCount = cart.item_count;
  // reset
  if (cart.item_count === 0) {
    localStorage.removeItem('upsell_shown');
    localStorage.removeItem('gift_shown');
  }
}
// run watcher
setInterval(watchCart, 800);
setTimeout(watchCart, 500);
// Added By MS 
let isAddingUpsell = false;
document.addEventListener('click', async function(e){
  const btn = e.target.closest('#fsr-add');
  if (!btn) return; 
  // Prevent multiple clicks
  if (isAddingUpsell) return;
  isAddingUpsell = true;
  // 🔄 LOADING START
  btn.disabled = true;
  btn.classList.add('loading');
  btn.innerText = "Adding...";
  try {
    const id = document.getElementById('fsr-variant').value;
    await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        id:id,
        quantity:1,
        properties:{ _upsell_added:"true" }
      })
    });
    
    // await fetch('/discount/FSRR150');
    console.log("✅ Upsell Added");
    closePopup('fsr');
    // OPEN GIFT AFTER UPSELL
    // if (!localStorage.getItem('gift_shown')) {
    //   const cart = await getCart();
    //   const giftItem = cart.items.find(i => i.properties?._trigger_gift == 'true');
    //   if (giftItem) {
    //     await loadProduct(giftItem.properties._gift_handle, 'gift');
    //     openPopup('gift');
    //     localStorage.setItem('gift_shown', 'true');
    //   }
    // }
    const cart = await getCart();
      const giftItem = cart.items.find(i => i.properties?._trigger_gift == 'true');

      // 🎁 CASE: Gift exists → open popup
      if (giftItem && !localStorage.getItem('gift_shown')) {
        window.currentTriggerProductId = giftItem.product_id; // ✅ ADD THIS LINE
        await loadProduct(giftItem.properties._gift_handle, 'gift');
        openPopup('gift');
        localStorage.setItem('gift_shown', 'true');
      }

      // 🔥 CASE: NO GIFT → refresh page
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
  } catch (err) {
    console.error("❌ Upsell Error:", err);
  }
  // RESET STATE
  isAddingUpsell = false;
  btn.disabled = false;
  btn.classList.remove('loading');
  btn.innerText = "Add to Cart";
});
// Added By MS END 
// UPSELL SKIP / CLOSE
document.addEventListener('click', async function(e){
  if (
    e.target.closest('#fsr-skip') ||
    e.target.closest('#fsr-close')
  ) {
    console.log("❌ Upsell Skipped");
    closePopup('fsr');
    // 🎁 OPEN GIFT AFTER SKIP
    if (!localStorage.getItem('gift_shown')) {
      const cart = await getCart();
      const giftItem = cart.items.find(
        i => i.properties?._trigger_gift == 'true'
      );
      if (giftItem) {
        await loadProduct(giftItem.properties._gift_handle, 'gift');
        openPopup('gift');
        localStorage.setItem('gift_shown', 'true');
      }
    }
  }
});
// GIFT ACTION
document.addEventListener('click', async function(e){
  if(e.target.id==='gift-add'){
    const id = document.getElementById('gift-variant').value;
    await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        id:id,
        quantity:1,
        properties:{ _free_gift_added:"true",_parent_product: window.currentTriggerProductId  }
      })
    });
    closePopup('gift');
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }
  if(e.target.id==='gift-close' || e.target.id==='gift-skip'){
    closePopup('gift');
  }
});
// VALIDATE CART
// async function validateCart(){
//   const cart = await getCart();
//   let hasTrigger = false;
//   cart.items.forEach(item=>{
//     if(
//       item.properties?._trigger_upsell == 'true' ||
//       item.properties?._trigger_gift == 'true'
//     ){
//       hasTrigger = true;
//     }
//   });
//   // ❌ REMOVE GIFT + DISCOUNT
//   if(!hasTrigger){
//     console.log("❌ Removing gift + discount");
//     for (let item of cart.items) {
//       if (item.properties?._free_gift_added == 'true') {
//         await fetch('/cart/change.js',{
//           method:'POST',
//           headers:{'Content-Type':'application/json'},
//           body:JSON.stringify({
//             id:item.key,
//             quantity:0
//           })
//         });
//         window.location.reload();
//       }
//     }
//     await fetch('/cart/update.js',{
//       method:'POST',
//       headers:{'Content-Type':'application/json'},
//       body:JSON.stringify({ discount:'' })
//     });
//   }
// }

async function syncGiftRemoval() {

  const freeGiftVariantIds = window.freeGiftVariantIds || [];

  const cart = await fetch('/cart.js').then(r => r.json());
  const items = cart.items;

  console.log("CART ITEMS:", items);

  // 👉 step 1: get all parent product IDs (normal products)
  const parentIds = items
    .filter(i => !i.properties?._free_gift_added)
    .map(i => i.product_id);

  console.log("PARENT IDS:", parentIds);

  // 👉 step 2: find gifts whose parent is missing
  const giftsToRemove = items.filter(i => {
    if (!i.properties?._parent_product) return false;
    return !parentIds.includes(Number(i.properties._parent_product));
  });

  console.log("GIFTS TO REMOVE:", giftsToRemove);

  // 👉 step 3: remove those gifts
  for (const gift of giftsToRemove) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: gift.variant_id,
        quantity: 0
      })
    });
  }
}
  syncGiftRemoval();



async function validateCart(){
  const cart = await getCart();

  // 🎯 Separate items
  const normalItems = cart.items.filter(item =>
    item.properties?._free_gift_added != 'true'
  );

  const giftItems = cart.items.filter(item =>
    item.properties?._free_gift_added == 'true'
  );

  // console.log("Normal Items:", normalItems.length);
  // console.log("Gift Items:", giftItems.length);

  // ❌ If NO normal items → remove gift
  if (normalItems.length === 0 && giftItems.length > 0) {

    console.log("❌ No main product → removing gift");

    for (let item of giftItems) {
      await fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          id:item.key,
          quantity:0
        })
      });
    }

    // 🔥 Remove discount too
    await fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({ discount:'' })
    });

    setTimeout(() => {
      window.location.reload();
    }, 400);
  }
}
// realtime validation
document.addEventListener('change',()=>{
  setTimeout(validateCart,800);
});
document.addEventListener('click',()=>{
  setTimeout(validateCart,800);
});
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(validateCart, 1000);
});
setInterval(validateCart, 3000);
// 🔁 UPDATE IMAGE WHEN VARIANT CHANGES IN POPUP
document.addEventListener('change', function(e){

  if (e.target.id === 'fsr-variant') {

    const variantId = e.target.value;

    let selectedVariant = null;

    // ✅ FIRST: metafield variants
    if (window.allowedUpsellVariants) {
      selectedVariant = window.allowedUpsellVariants.find(v => v.id == variantId);
    }

    // fallback
    if (!selectedVariant && window.fsrProductData) {
      selectedVariant = window.fsrProductData.variants.find(v => v.id == variantId);
    }

    if (selectedVariant?.featured_image?.src) {
      let img = selectedVariant.featured_image.src;

      if (img.startsWith('//')) img = 'https:' + img;

      document.getElementById('fsr-img').src = img;
    }

        // Added by MS
    const variantPrice = document.querySelector('.img-title-data .variant-price');
    // variantPrice.innerText = formatMoney(selectedVariant.price,window.Shopify.money_format);


    let displayPrice = selectedVariant.price;

    if (window.upsellPriceMap && window.upsellPriceMap[selectedVariant.id]) {
      displayPrice = window.upsellPriceMap[selectedVariant.id];
    }

    variantPrice.innerText = formatMoney(displayPrice, window.Shopify.money_format);


  }

});